import { posFoodLogo } from 'constants/ui/svg';
import { useAppDispatch } from 'hooks';
import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { authActions } from 'slices/authSlice';
import logoRank from '../../assets/images/logo.png';
import { Button } from 'antd';
import { shopSettingActions } from 'slices/shopSettingSlice';
import { getToken } from 'helpers';
export const LoginPage = () => {
  const isChrome =
    typeof window !== 'undefined' &&
    'chrome' in window &&
    (!!(window.chrome as any)?.webstore || !!(window.chrome as any)?.runtime);
  const userAgent = window.navigator.userAgent;
  const isAndroid = /Android/.test(userAgent);
  const isIOS = /iPhone|iPad|iPod/.test(userAgent);
  const token = getToken();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const containerRef = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [state, setState] = useState({
    email: '',
    password: '',
    remember_me: false,
  });

  const onLogin = () => {
    if (state.email !== '' && state.password !== '') {
      dispatch(authActions.login({ state }));
    } else {
      console.log('login fail');
    }
  };
  const handleToggleFullscreen = () => {
    const el = containerRef.current;
    if (!el) return;

    if (!document.fullscreenElement) {
      el.requestFullscreen?.();
    } else {
      document.exitFullscreen?.();
    }
  };
  useEffect(() => {
    if (token) {
      navigate('/settings');
    }
    dispatch(authActions.resetMasterPermission());
    dispatch(shopSettingActions.resetPermissionByUser());
  }, []);
  return (
    <div
      ref={containerRef}
      // [@media(max-height:450px)]:h-[150vh]
      className={`flex bg-white flex-col items-center justify-center  w-[100vw] px-4 gap-5 sm:px-[25vw] lg:px-[34vw] ${
        isIOS && !isChrome ? 'h-[110vh]' : 'h-[100vh]'
      }`}
    >
      {/* logo */}
      <img className="mb-[8px]" src={logoRank} />
      {/* {posFoodLogo} */}
      {/* login form */}
      <div className="flex flex-col p-4 w-full rounded-xl border border-solid border-border-gray">
        <div className="flex flex-col gap-4 mb-8">
          {/* email */}
          <div className="flex flex-col gap-2 font-medium">
            <span className="text-[#252B37] text-[14px] notosans_medium">{t('EMAIL_ONLY')}</span>
            {/* <input
              style={{
                justifyContent: 'center',
                alignItems: 'center',
              }}
              onChange={(e) => setState({ ...state, email: e.target.value })}
              type="text"
              placeholder="account@gmail.com"
              className="flex flex-1 px-4 py-3 h-full bg-transparent rounded-lg border border-solid outline-none border-border-gray"
            /> */}

            <div className="flex border border-solid border-border-gray rounded-lg px-4 h-[40px]">
              <input
                onChange={(e) => setState({ ...state, email: e.target.value })}
                type={'text'}
                placeholder="account@gmail.com"
                className="pr-2 w-full h-full bg-transparent outline-none notosans_normal"
              />
            </div>
          </div>
          {/* password */}
          <div className="flex flex-col gap-2 font-medium">
            <span className="text-[#252B37] text-[14px] notosans_medium">{t('PASSWORD')}</span>
            <div className="flex border border-solid border-border-gray rounded-lg px-4 h-[40px] items-center">
              <input
                onChange={(e) => setState({ ...state, password: e.target.value })}
                type={showPassword ? 'text' : 'password'}
                placeholder={t('PASSWORD')}
                className="pr-2 w-full h-full bg-transparent outline-none notosans_normal"
              />
              {showPassword ? (
                <FiEye
                  size={16}
                  color="#666687"
                  onClick={() => setShowPassword(false)}
                  className="items-center"
                />
              ) : (
                <FiEyeOff
                  size={16}
                  color="#666687"
                  onClick={() => setShowPassword(true)}
                  className="items-center"
                />
              )}
            </div>
          </div>
          {/* remeber me */}
          <div className="flex items-center gap-2 mt-[10px]">
            <input
              type="checkbox"
              className="w-4 h-4"
              checked={state.remember_me}
              onChange={() => setState({ ...state, remember_me: !state.remember_me })}
            />
            <span className="text-[#252B37] text-[14px] notosans_normal">{t('REMEMBER_ME')}</span>

            <span className="flex flex-1 justify-end text-[#666687] text-[14px] notosans_medium">
              {t('FORGOT_PASSWORD')}
            </span>
          </div>
        </div>
        {/* login button */}
        <Button
          className="bg-text-secondary hover:text-white rounded-lg px-4 h-[40px] text-white text-[16px] notosans_medium hover:bg-text-secondary"
          onClick={onLogin}
          // onClick={handleToggleFullscreen}
        >
          {t('LOGIN')}
        </Button>
      </div>
    </div>
  );
};
